import Logger from './logger';

export const sanitizeEmailInput = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  // Remove whitespace and ASCII control chars, but everything else should be
  // preserved.
  // eslint-disable-next-line no-control-regex
  return value.replace(/[\s\u0000-\u001F\u007F]+/g, '');
};

let hasLoggedMissingInput = false;

const createEmailValidationInput = () => {
  if (typeof document === 'undefined') {
    Logger.warn('[emailValidation] document is unavailable; HTML5 email validity check disabled');
    return null;
  }

  try {
    const input = document.createElement('input');
    input.type = 'email';
    return input;
  } catch (error) {
    Logger.error(`[emailValidation] failed to create detached email input: ${error}`);
    return null;
  }
};

let emailValidationInput = createEmailValidationInput();

// Visible only for test purposes.
export function nullOutEmailValidationInput() {
  emailValidationInput = null;
}

const logMissingInputOnce = () => {
  if (!hasLoggedMissingInput) {
    hasLoggedMissingInput = true;
    Logger.warn('[emailValidation] detached email input unavailable; defaulting behavior to `true`');
  }
};

/** Validates email addresses against HTML5 specifications, using a detatched
 *  document element.
 *  This utility is called from data-level validators. We cannot rely on built-in
 *  document element validity behavior here without broader form/input API refactors.
 */
export const isHtml5EmailValid = (value) => {
  if (typeof value !== 'string') {
    return false;
  }
  if (!emailValidationInput) {
    logMissingInputOnce();
    return true;
  }

  emailValidationInput.value = value;
  return emailValidationInput.checkValidity();
};
